var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "tr",
    {
      class:
        _vm.pharmacist && _vm.assignedPharmacist?._id === _vm.pharmacist._id
          ? "already-allocated"
          : "",
      attrs: { "data-id": _vm.pharmacist?._id || _vm.pharmacistId },
    },
    [
      _vm.hydrationError
        ? _c(
            "td",
            { staticClass: "hydration-error", attrs: { colspan: "8" } },
            [
              _c("span", [
                _vm._v(
                  "Freiberufler " +
                    _vm._s(_vm.pharmacistId) +
                    " konnte nicht geladen werden."
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "retry-hydration ml-2",
                  attrs: { "x-small": "" },
                  on: { click: _vm.hydrateApplicant },
                },
                [_vm._v("\n            Erneut versuchen\n        ")]
              ),
            ],
            1
          )
        : _vm.pharmacist
        ? [
            _c("td", [
              _c(
                "div",
                { class: _vm.getPharmacistAvailabilityStatus.classes },
                [
                  _vm.assignedPharmacist?._id === _vm.pharmacist._id
                    ? _c(
                        "v-icon",
                        { staticClass: "mb-1 mr-1", attrs: { small: "" } },
                        [
                          _vm._v(
                            "\n                mdi-check-circle\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: `/pharmacists/${_vm.pharmacist._id}`,
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            `${_vm.pharmacist.firstname} ${_vm.pharmacist.lastname}`
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.requestDate))]),
            _vm._v(" "),
            _c("td", { style: { color: _vm.travelCostColor } }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.travelCostDistance) +
                  " km / " +
                  _vm._s(_vm.travelCostCosts) +
                  " €\n    "
              ),
            ]),
            _vm._v(" "),
            _c("td", [
              _c(
                "span",
                {
                  style: {
                    color:
                      +_vm.pharmacist.erp_expertise[_vm.pharmacy.erp] >= 2 ||
                      _vm.pharmacist.erp_counts[_vm.pharmacy.erp] >= 2
                        ? "green"
                        : "red",
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.pharmacist.erp_expertise[_vm.pharmacy.erp]) +
                      "/3 (" +
                      _vm._s(_vm.pharmacist.erp_counts[_vm.pharmacy.erp]) +
                      ")\n        "
                  ),
                ]
              ),
              _vm._v("\n        |\n        "),
              _c(
                "span",
                {
                  staticClass: "hba-status",
                  style: {
                    color:
                      _vm.appointment.hba && !_vm.pharmacist.has_hba
                        ? "red"
                        : "green",
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.pharmacist.has_hba ? "HBA vorhanden" : "Kein HBA"
                      ) +
                      "\n        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "known-pharmacist-status",
                style: { color: _vm.isKnownPharmacist ? "green" : "red" },
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.isKnownPharmacist ? "Ja" : "Nein")),
                ]),
                _vm._v(" "),
                _vm.isFavoritePharmacist
                  ? _c(
                      "v-icon",
                      { staticClass: "ml-1 favorite", attrs: { small: "" } },
                      [_vm._v("\n            mdi-heart\n        ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("td", { staticClass: "message" }, [
              _vm._v(_vm._s(_vm.requestMessage)),
            ]),
            _vm._v(" "),
            _c(
              "td",
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "accept",
                    attrs: {
                      disabled:
                        !_vm.selectionEnabled ||
                        !_vm.canManageRequests() ||
                        _vm.disableAcceptance ||
                        !_vm.getPharmacistAvailabilityStatus.canAssign,
                      "x-small": "",
                      color: "success",
                    },
                    on: { click: _vm.accept },
                  },
                  [_vm._v("\n            Auswählen\n        ")]
                ),
                _vm._v(" "),
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "reject",
                      attrs: {
                        disabled:
                          !_vm.selectionEnabled ||
                          !_vm.canManageRequests() ||
                          _vm.disableRejection,
                        "x-small": "",
                        color: "error",
                      },
                      on: { click: _vm.openRejectionDialog },
                    },
                    [_vm._v("Absage\n            ")]
                  ),
                  _vm._v(" "),
                  _vm.selectionEnabled
                    ? _c("rejection-dialog", {
                        on: { "confirm-rejection": _vm.reject },
                        model: {
                          value: _vm.isRejectionDialogOpen,
                          callback: function ($$v) {
                            _vm.isRejectionDialogOpen = $$v
                          },
                          expression: "isRejectionDialogOpen",
                        },
                      })
                    : _vm._e(),
                ],
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "status",
                style: {
                  color:
                    _vm.requestStatus.toLowerCase() === "accepted"
                      ? "green"
                      : _vm.requestStatus.toLowerCase() === "rerequested"
                      ? "orange"
                      : _vm.requestStatus.toLowerCase() ===
                        "cancellationwithdrawn"
                      ? "blue"
                      : "red",
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.getStatusName) + "\n    ")]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }